var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card-actions',[_c('v-spacer'),_c('v-btn',{attrs:{"text":""},on:{"click":_vm.$_onClickCancel}},[_vm._v(_vm._s(('pwa.install.cancell')))]),_c('v-btn',{attrs:{"text":"","color":"primary"},on:{"click":_vm.$_onClickInstall}},[_vm._v(_vm._s(('pwa.install.install')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }